module.exports = __webpack_public_path__ + "img/loghi_0007_csv_vicenza.9f689037.png";